var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconReply1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2222 20H8.33333C8.30321 20 8.2734 19.9987 8.24395 19.9961L2.44721 22.8944C1.68306 23.2765 0.822646 22.5863 1.02986 21.7575L2.34801 16.4849C0.847753 14.8795 0 12.6983 0 10.5C0 5.18874 5.42072 1 12 1C18.5793 1 24 5.18874 24 10.5C24 13.8264 21.8465 16.8908 18.573 18.6322C16.9085 19.5176 15.0514 20 13.2222 20ZM3.7231 15.0252C2.62567 13.8024 2 12.1532 2 10.5C2 6.42242 6.42902 3 12 3C17.571 3 22 6.42242 22 10.5C22 13.0258 20.2964 15.45 17.6337 16.8664C16.2527 17.6011 14.7169 18 13.2222 18H8.33333C8.27645 18 8.22068 18.0047 8.1664 18.0139C7.96439 17.9796 7.75008 18.0069 7.55279 18.1056L3.49747 20.1332L4.47014 16.2425C4.60409 15.7067 4.27833 15.1638 3.74254 15.0299C3.73606 15.0282 3.72958 15.0267 3.7231 15.0252Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9C19 9.55228 18.5523 10 18 10H6C5.44772 10 5 9.55228 5 9ZM5 13C5 12.4477 5.44772 12 6 12H15.5C16.0523 12 16.5 12.4477 16.5 13C16.5 13.5523 16.0523 14 15.5 14H6C5.44772 14 5 13.5523 5 13Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconReply1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconReply1.9dfaef044efaf5bbc6cf8406bd8d18a6.svg";